import React, { useCallback, useEffect, useState, } from 'react';
import classNames from 'classnames';
import s from './Main.scss';
import { Menu } from './components/Menu/Menu';
import { SpeedSelector } from './components/SpeedSelector';
import { useView, View } from '../../../providers/ViewProvider';
import { QualitySelector } from './components/QualitySelector';
import { SubtitlesSelector } from './components/SubtitlesSelector';
import { useSettings } from '../../../providers/SettingsProvider';
export const Main = () => {
    const [expanded, setExpanded] = useState(false);
    const { view, setView } = useView();
    const { config: { speedEnabled }, qualityState, subtitlesState, } = useSettings();
    const itemCount = +!!speedEnabled + +!!qualityState + +!!subtitlesState;
    const handleTransitionEnd = useCallback((e) => {
        if (e.propertyName === 'transform' && !expanded) {
            setView(View.Menu);
        }
    }, [expanded, setView]);
    const handleBackClicked = useCallback(() => {
        setExpanded(false);
    }, []);
    useEffect(() => {
        if (view !== View.Menu) {
            setExpanded(true);
        }
    }, [view]);
    return (React.createElement("div", { onTransitionEnd: handleTransitionEnd, className: classNames(s.main, {
            [s.open]: expanded,
            [s.twoItem]: itemCount === 2,
            [s.threeItem]: itemCount === 3,
        }) },
        React.createElement(Menu, { visible: !expanded || view === View.Menu }),
        view === View.Speed ? (React.createElement(SpeedSelector, { visible: expanded, onBackButtonClick: handleBackClicked })) : null,
        view === View.Quality ? (React.createElement(QualitySelector, { visible: expanded, onBackButtonClick: handleBackClicked })) : null,
        view === View.Subtitles ? (React.createElement(SubtitlesSelector, { visible: expanded, onBackButtonClick: handleBackClicked })) : null));
};
//# sourceMappingURL=Main.js.map